/**
 * MotoMillion Category Tree Builder
 * Extracted from inline Liquid to reduce server-side render time.
 *
 * Requires mm-moto-tree-data.js to be loaded first (sets window.MM_MOTO_TREE_DATA).
 * Each [data-mm-moto-tree-root] element must still contain an inline
 * <script type="application/json" data-mm-moto-values-json> with the Liquid-generated
 * filter values for that specific filter instance.
 */
(function () {
  function buildTree(root) {
    if (!root || root.dataset.mmMotoTreeBuilt === 'true') return;

    var mount = root.querySelector('[data-mm-moto-tree-mount]');
    if (!mount) return;

    function sortMotoTree(node) {
      if (!node || !Array.isArray(node.children)) return node;
      node.children = node.children
        .map(function (child) { return sortMotoTree(child); })
        .sort(function (a, b) {
          return (a.name || '').localeCompare(b.name || '', undefined, {
            sensitivity: 'base',
            numeric: true
          });
        });
      return node;
    }

    /* ---- data sources ---- */
    var treeSource = window.MM_MOTO_TREE_DATA;
    if (!treeSource) {
      // Fallback: try reading from an inline JSON element (backwards-compat)
      var inlineEl = root.querySelector('[data-mm-moto-tree-json]');
      if (inlineEl) {
        try { treeSource = JSON.parse(inlineEl.textContent); } catch (e) { return; }
      } else {
        return;
      }
    }

    // Deep-clone so sorting doesn't mutate the shared global
    var tree = sortMotoTree(JSON.parse(JSON.stringify(treeSource)));

    var valuesEl = root.querySelector('[data-mm-moto-values-json]');
    if (!valuesEl) return;
    var values;
    try { values = JSON.parse(valuesEl.textContent); } catch (e) { return; }

    root.dataset.mmMotoTreeBuilt = 'true';

    var showCount = root.dataset.showCount === 'true';

    var preferredPaths = {
      'heated gear': 'Motorcycles > Riding Gear > Heated Gear'
    };

    function decodeHtmlEntities(value) {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = value || '';
      return textarea.value;
    }

    var normalize = function (value) { return (value || '').toString().trim().toLowerCase(); };
    var pathToString = function (pathArray) { return pathArray.join(' > '); };

    var valuesByLabel = new Map();
    values.forEach(function (item) {
      item.label = decodeHtmlEntities(item.label);
      item.value = decodeHtmlEntities(item.value);
      item.visible = item.active || Number(item.count) > 0;
      if (!item.visible) return;
      var key = normalize(item.label);
      if (!valuesByLabel.has(key)) valuesByLabel.set(key, []);
      valuesByLabel.get(key).push(item);
    });

    var claimed = new Set();

    function getPathMatches(nodePath) {
      var label = nodePath[nodePath.length - 1];
      var key = normalize(label);
      var matches = valuesByLabel.get(key) || [];
      if (!matches.length) return [];
      var preferredPath = preferredPaths[key];
      if (!preferredPath) return matches;
      return preferredPath === pathToString(nodePath) ? matches : [];
    }

    function claimValueForNode(nodePath) {
      var matches = getPathMatches(nodePath);
      if (!matches.length) return null;
      var unused = matches.find(function (item) { return !claimed.has(item.uid); });
      if (!unused) return null;
      claimed.add(unused.uid);
      return unused;
    }

    function buildCheckbox(item, idSuffix) {
      var li = document.createElement('li');
      li.className = 'faceted-filter-group-display__list-item mm-moto-item';

      var label = document.createElement('label');
      label.className = 'faceted-filter-group-display__list-item-label';
      label.setAttribute('for', idSuffix);

      var input = document.createElement('input');
      input.className = 'faceted-filter-group-display__list-item-input';
      input.type = 'checkbox';
      input.name = item.param_name;
      input.value = item.value;
      input.id = idSuffix;
      if (item.active) input.checked = true;

      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('class', 'faceted-filter-group-display__checkmark');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      svg.setAttribute('role', 'presentation');
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
      svg.setAttribute('viewBox', '0 0 14 14');

      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('class', 'faceted-filter-group-display__checkmark-check');
      path.setAttribute('fill', 'none');
      path.setAttribute('d', 'M2.5 7L5.5 10L11.5 4');
      svg.appendChild(path);

      var text = document.createElement('span');
      text.className = 'faceted-filter-group-display__list-item-label-text';
      text.textContent = showCount ? item.label + ' (' + item.count + ')' : item.label;

      label.appendChild(input);
      label.appendChild(svg);
      label.appendChild(text);
      li.appendChild(label);

      return li;
    }

    function renderNode(node, path) {
      var nodePath = path.concat([node.name]);
      var directValue = claimValueForNode(nodePath);

      var childElements = [];
      var hasActiveDescendant = !!(directValue && directValue.active);

      if (Array.isArray(node.children) && node.children.length) {
        node.children.forEach(function (child) {
          var renderedChild = renderNode(child, nodePath);
          if (renderedChild) {
            childElements.push(renderedChild.element);
            if (renderedChild.hasActive) hasActiveDescendant = true;
          }
        });
      }

      var directVisible = !!directValue;

      if (!directVisible && childElements.length === 0) {
        return null;
      }

      if (childElements.length > 0) {
        var details = document.createElement('details');
        details.className = 'mm-moto-accordion mm-moto-accordion--level-' + Math.min(nodePath.length - 1, 5);
        if (hasActiveDescendant) details.open = true;

        var summary = document.createElement('summary');
        var summaryText = document.createElement('span');
        summaryText.textContent = node.name;
        summary.appendChild(summaryText);

        var body = document.createElement('div');
        body.className = 'mm-moto-accordion__body';

        if (directVisible) {
          body.appendChild(
            buildCheckbox(
              directValue,
              'MM-Filter-' + normalize(node.name).replace(/[^a-z0-9]+/g, '-') + '-' + directValue.uid
            )
          );
        }

        childElements.forEach(function (childElement) { body.appendChild(childElement); });

        details.appendChild(summary);
        details.appendChild(body);

        return { element: details, hasActive: hasActiveDescendant };
      }

      if (!directVisible) return null;

      return {
        element: buildCheckbox(
          directValue,
          'MM-Filter-' + normalize(node.name).replace(/[^a-z0-9]+/g, '-') + '-' + directValue.uid
        ),
        hasActive: !!directValue.active
      };
    }

    var outerDisplay = root.closest('.faceted-filter-group-display');
    var outerGroup = root.closest('.faceted-filter-group');

    function syncOuterDisplayHeight() {
      if (!outerDisplay || !outerGroup) return;
      if (!outerGroup.open) return;

      var outerSummary = outerGroup.querySelector(':scope > summary');
      var summaryHeight = outerSummary ? outerSummary.offsetHeight : 0;

      outerDisplay.style.height = 'auto';
      outerDisplay.style.maxHeight = 'none';
      outerDisplay.style.overflow = 'hidden';

      var displayHeight = outerDisplay.scrollHeight;
      var totalHeight = summaryHeight + displayHeight;

      outerGroup.style.height = totalHeight + 'px';
      outerGroup.style.maxHeight = totalHeight + 'px';
      outerGroup.style.overflow = 'hidden';
    }

    function scheduleOuterDisplayHeightSync() {
      requestAnimationFrame(function () {
        requestAnimationFrame(syncOuterDisplayHeight);
      });
    }

    function flattenSinglePathMount() {
      mount.classList.remove('mm-moto-tree--flattened');

      var topLevelNodes = Array.from(mount.children).filter(function (element) {
        return element.classList.contains('mm-moto-accordion') || element.classList.contains('mm-moto-item');
      });

      if (topLevelNodes.length !== 1 || !topLevelNodes[0].classList.contains('mm-moto-accordion')) {
        return;
      }

      var current = topLevelNodes[0];

      while (current && current.classList.contains('mm-moto-accordion')) {
        var body = current.querySelector(':scope > .mm-moto-accordion__body');
        if (!body) break;

        var bodyChildren = Array.from(body.children).filter(function (element) {
          return element.classList.contains('mm-moto-accordion') || element.classList.contains('mm-moto-item');
        });

        var childAccordions = bodyChildren.filter(function (element) { return element.classList.contains('mm-moto-accordion'); });
        var childItems = bodyChildren.filter(function (element) { return element.classList.contains('mm-moto-item'); });

        if (childItems.length > 0 && childAccordions.length === 0) {
          mount.innerHTML = '';
          bodyChildren.forEach(function (element) { mount.appendChild(element); });
          return;
        }

        if (childItems.length === 0 && childAccordions.length === 1 && bodyChildren.length === 1) {
          current = childAccordions[0];
          continue;
        }

        if (childItems.length === 0 && childAccordions.length > 1 && bodyChildren.length === childAccordions.length) {
          mount.innerHTML = '';
          bodyChildren.forEach(function (element) { mount.appendChild(element); });
          return;
        }

        break;
      }

      if (current && current !== topLevelNodes[0]) {
        mount.innerHTML = '';
        mount.appendChild(current);
      }
    }

    /* ---- render ---- */
    mount.innerHTML = '';

    (tree.children || []).forEach(function (child) {
      var rendered = renderNode(child, [tree.name]);
      if (rendered) mount.appendChild(rendered.element);
    });

    flattenSinglePathMount();

    /* ---- event listeners ---- */
    root.addEventListener('toggle', function (event) {
      if (event.target && event.target.classList && event.target.classList.contains('mm-moto-accordion')) {
        scheduleOuterDisplayHeightSync();
      }
    }, true);

    root.addEventListener('click', function (event) {
      var summary = event.target.closest('.mm-moto-accordion > summary');
      if (summary) {
        scheduleOuterDisplayHeightSync();
      }
    }, true);

    if (outerGroup) {
      outerGroup.addEventListener('toggle', function () {
        if (outerGroup.open) {
          scheduleOuterDisplayHeightSync();
        } else {
          outerGroup.style.height = '';
          outerGroup.style.maxHeight = '';
          outerGroup.style.overflow = '';
          outerDisplay.style.height = '';
          outerDisplay.style.maxHeight = '';
          outerDisplay.style.overflow = '';
        }
      });
    }

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(scheduleOuterDisplayHeightSync);
      resizeObserver.observe(mount);
      if (outerGroup) resizeObserver.observe(outerGroup);
    }

    scheduleOuterDisplayHeightSync();
  }

  /* ---- auto-init ---- */
  function initAllTrees() {
    document.querySelectorAll('[data-mm-moto-tree-root]').forEach(buildTree);
  }

  function rebuildAllTrees(scope) {
    (scope || document).querySelectorAll('[data-mm-moto-tree-root]').forEach(function (root) {
      root.dataset.mmMotoTreeBuilt = 'false';
      var mount = root.querySelector('[data-mm-moto-tree-mount]');
      if (mount) mount.innerHTML = '';
      buildTree(root);
    });
  }

  function syncOpenTreeHeights(scope) {
    (scope || document).querySelectorAll('[data-mm-moto-tree-root]').forEach(function (root) {
      var outerGroup = root.closest('.faceted-filter-group');
      var outerDisplay = root.closest('.faceted-filter-group-display');
      if (!outerGroup || !outerDisplay || !outerGroup.open) return;

      var outerSummary = outerGroup.querySelector(':scope > summary');
      var summaryHeight = outerSummary ? outerSummary.offsetHeight : 0;
      outerDisplay.style.height = 'auto';
      outerDisplay.style.maxHeight = 'none';
      outerDisplay.style.overflow = 'hidden';
      var totalHeight = summaryHeight + outerDisplay.scrollHeight;
      outerGroup.style.height = totalHeight + 'px';
      outerGroup.style.maxHeight = totalHeight + 'px';
      outerGroup.style.overflow = 'hidden';
    });
  }

  // Expose globally so it can be called after dynamic content loads
  window.mmMotoTreeBuild = buildTree;
  window.mmMotoTreeInitAll = initAllTrees;
  window.mmMotoTreeRebuildAll = rebuildAllTrees;
  window.mmMotoTreeSyncHeights = syncOpenTreeHeights;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllTrees);
  } else {
    initAllTrees();
  }

  window.addEventListener('load', initAllTrees);
  window.addEventListener('pageshow', initAllTrees);

  document.addEventListener('shopify:section:load', function (event) {
    rebuildAllTrees(event.target || document);
  });

  document.addEventListener('mm:filter:resize', function (event) {
    var scope = event.target || document;
    initAllTrees();
    requestAnimationFrame(function () { syncOpenTreeHeights(scope); });
  });
})();
